<template>
  <div id="app">
    <router-view :class="beian.length ? 'router_view' : 'h100'" />
    <div v-if="beian.length" class="ICP w100 lh36 fs12 c9 flex_center">
      <span>{{ beian[0] }}</span>
      <a class="linkba c9 ml20" href="http://beian.miit.gov.cn/">{{ beian[1] }}</a>
    </div>
  </div>
</template>

<script>
import { getLocationUri } from '@/utils/fn'
const test_map = {
  'test.chonghai.net': ['九江崇海网络科技有限公司', '赣ICP备2020012350号-1'],
  'test.hnchongmao.com': ['湖南崇茂网络科技有限公司', '湘ICP备2021007788号-1']
}
const production_map = {
  'www.chonghai.net': ['九江崇海网络科技有限公司', '赣ICP备2020012350号-1'],
  'www.hnchongmao.com': ['湖南崇茂网络科技有限公司', '湘ICP备2021007788号-1']
}
const development_map = {
  'localhost:8766': ['九江崇海网络科技有限公司', '赣ICP备2020012350号-1'],
  'localhost:8767': ['湖南崇茂网络科技有限公司', '湘ICP备2021007788号-1']
}
export default {
  name: 'App',
  data() {
    return {
      beian: []
    }
  },
  created() {
    const env = process.env.VUE_APP_ENV
    const uri = getLocationUri()
    switch (env) {
      // 生产环境
      case 'production':
        this.beian = production_map[uri]
        break
      // 测试环境
      case 'test':
        this.beian = test_map[uri]
        break
      // 开发环境
      default:
        this.beian = development_map[uri]
        break
    }
  }
}
</script>
<style lang="scss" scoped>
#app{
  background-color: #f5f5f5;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.ICP{
  position: fixed;
  left: 0;
  background: #F5F9FF;
  bottom: 0;
  .linkba:hover{
    color: #666;
    text-decoration: underline;
  }
}
.router_view{
  height: calc(100% - 36px);
}
</style>
